import React from "react";
import { Megaphone, ChevronRight } from "lucide-react";
import { useApp } from "../context/AppContext";

export const AvisoAlertaTopo = () => {
  const { naoLidasChat, openChat } = useApp();
  const n = naoLidasChat?.avisos || 0;
  if (n <= 0) return null;
  return (
    <button
      onClick={() => openChat("avisos")}
      data-testid="aviso-alerta-topo"
      className="w-full flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-left hover:bg-amber-100 transition-colors animate-pulse"
    >
      <span className="w-9 h-9 rounded-lg bg-amber-500 text-white flex items-center justify-center shrink-0">
        <Megaphone className="w-5 h-5" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-900">
          Você tem {n} aviso{n > 1 ? "s" : ""} importante{n > 1 ? "s" : ""} para ler
        </p>
        <p className="text-xs text-amber-700">Clique aqui para abrir e ler agora.</p>
      </div>
      <ChevronRight className="w-5 h-5 text-amber-600 shrink-0" />
    </button>
  );
};

export default AvisoAlertaTopo;
